<template>
  <v-card
      class="mx-auto"
      max-width="700px"
    >

      <v-card-title class="blue-bg">
        <span class="title font-weight-bold">Test de asociaciones implícitas -- Fundació Èpica</span>
      </v-card-title>

      <v-card-text class=" font-weight-light ">
        <v-row align="center" justify="center" >
          <v-col cols="12" class="text-center mt-4">
            <v-icon v-if="!loader" color="black" large>mdi-emoticon-cool-outline</v-icon>
            <v-progress-circular v-if="loader"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <p v-if="loader">Enviando resultados</p>
          </v-col>
          <v-col cols="12" class="text-center">
            <p class="title mt-2">Test finalizado</p>
            <p class="title font-weight-light mt-2">La Fundación Épica, el Instituto de Investigación Biomédica de Bellvitge y el Instituto de Neurociencias de la Universidad de Barcelona, te agradecen el tiempo que has dedicado a esta actividad </p>
          </v-col>
        </v-row> 
      </v-card-text>

      <v-card-actions>
      </v-card-actions>
    </v-card>
</template>

<script>

import { mapState } from 'vuex'
import { mdiEmoticonCoolOutline } from '@mdi/js'

export default {
  name: 'CardThanks',
  props: [],
  data: () => ({
    loader : true
    }),
  mounted(){
    this.loader = true;
    this.$axios({
        method: 'post',
        url: 'https://iat.iglor.es/iat/answers',
        data: this.results,
        headers: {
                'Content-Type': 'application/json'
        }
      }).then( (response) => {
        // handle success
        this.loader =false
        console.log(response);
      })
      .catch( (error) => {
        // handle error
        console.log(error);
      });
  },
  methods:{
  },
  computed:{
    results(){
      let out = {}
      out.userID = this.$store.state.sessionId
      out.timestamp = this.$store.state.timestamp
      out.answers = this.$store.state.answers
      return out
    }
  }
};
</script>

<style>

</style>

